export default __webpack_public_path__ + "media/images/hygiene-03ec014ac5c6d0a2908629717e36ed41.png";